import { render, staticRenderFns } from "./BizRNumForm.vue?vue&type=template&id=5e539d48&scoped=true&lang=pug&"
import script from "./BizRNumForm.vue?vue&type=script&lang=ts&"
export * from "./BizRNumForm.vue?vue&type=script&lang=ts&"
import style0 from "./BizRNumForm.vue?vue&type=style&index=0&id=5e539d48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e539d48",
  null
  
)

export default component.exports